import {FC, SyntheticEvent} from "react";

import * as styles from "./style.module.css";

import avaSvg from "#app/assets/images/user_avatar.svg";
import errorSvg from "#app/assets/icons/hint_error.svg";
import hintSvg from "#app/assets/icons/hint_hint.svg";
import clsx from "clsx";

interface AvatarHintInterface { status: "error" | "hint" }

interface IAvatar {
    size?: "small" | "middle" | "large" | "beforegiant" | "giant" | "enormous"; // @TODO поправить нейминг, скорее всего enormous это обычный размер
    onClick?: () => void;
    imgUrl?: string | null;
    hint?: AvatarHintInterface | null | undefined
}

const Avatar: FC<IAvatar> = (
    {
        size = "middle",
        onClick,
        imgUrl,
        hint = null
    }) => {

    const handleClick = () => {
        if (typeof onClick === "function") onClick();
    };

    const handleImageError = (e: SyntheticEvent<HTMLImageElement>) => {
        const target = e.target as HTMLImageElement; // Устанавливаем дефолтное изображение, если текущее не загружено
        target.src = avaSvg;
    };

    const AvatarHint: FC<AvatarHintInterface> = ({
                                                     status
    }) => {
        return (
            <div className={styles['imageHintContainer']}>
                <img className={clsx(styles['imageHintIcon'], {[styles["imageBackgroundValid"]]: status === 'hint'})} src={status === 'hint' ? hintSvg : errorSvg} alt={``}/>
                <div className={styles['imageHintPopup']}>
                    {`Аккаунт Aton ${(status === 'hint' ? 'прикреплен' : 'откреплен')}`}
                </div>
            </div>
        );
    }

    return (
        <div
            className={`avatar-img-container ${styles["container"]} ${size ? styles[size] : ""} ${onClick ? styles["pointer"] : ""}`}
            onClick={handleClick}
        >
            {hint && (
                <AvatarHint status={hint.status} />
            )}
            <img src={imgUrl ?? ""} alt="profile" onError={handleImageError}/>
        </div>
    );
};

export default Avatar;